import Layout from '../../components/ui/Layout';
import { SettingsNav } from './Branches';

export default function Notifications() {
  const triggers = [
    { label: 'Crash detection alert', channels: ['Push', 'Email'], roles: 'Manager' },
    { label: 'Failed check', channels: ['Push'], roles: 'Manager' },
    { label: 'Check reminder', channels: ['Push'], roles: 'Operator, Driver' },
    { label: 'Overdue escalation', channels: ['Push', 'Email'], roles: 'Manager' },
    { label: 'Derv low alert', channels: ['Push'], roles: 'Fuel manager' },
    { label: 'Daily branch summary', channels: ['Email'], roles: 'Manager' },
    { label: 'Weekly group report', channels: ['Email'], roles: 'Senior manager' },
    { label: 'MOT expiry warning', channels: ['Push', 'Email'], roles: 'Manager, Senior manager' },
    { label: 'Licence expiry warning', channels: ['Push', 'Email'], roles: 'Manager' },
  ];

  return (
    <Layout>
      <div style={{ display: 'flex', flex: 1, minHeight: '100vh' }}>
        <SettingsNav active="Notifications" />
        <div style={{ flex: 1, padding: 'var(--main-padding)' }}>
          <h1 style={{ fontSize: 22, fontWeight: 400, marginBottom: 4 }}>Notifications</h1>
          <p style={{ fontSize: 13, color: 'var(--color-text-tertiary)', marginBottom: 24 }}>Configure notification triggers and channels</p>
          <div style={{ background: 'var(--color-bg-primary)', border: '0.5px solid var(--color-border-light)', borderRadius: 'var(--radius-lg)', overflow: 'hidden' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', padding: '8px 18px', borderBottom: '0.5px solid var(--color-border-light)', background: 'var(--color-bg-secondary)' }}>
              {['Trigger', 'Channels', 'Recipients'].map(h => (
                <div key={h} style={{ fontSize: 10, fontWeight: 400, color: 'var(--color-text-tertiary)', letterSpacing: '0.04em' }}>{h}</div>
              ))}
            </div>
            {triggers.map((t, i) => (
              <div key={i} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', padding: '14px 18px', borderBottom: i < triggers.length - 1 ? '0.5px solid var(--color-border-light)' : 'none', alignItems: 'center' }}>
                <div style={{ fontSize: 13, color: 'var(--color-text-primary)' }}>{t.label}</div>
                <div style={{ display: 'flex', gap: 5 }}>
                  {t.channels.map(c => (
                    <span key={c} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 20, background: c === 'Push' ? '#E6F1FB' : 'var(--color-brand-light)', color: c === 'Push' ? '#185FA5' : 'var(--color-brand)' }}>{c}</span>
                  ))}
                </div>
                <div style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>{t.roles}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}
